module.exports = __webpack_public_path__ + "static/media/Slide25.2cb26481.jpg";